var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { View, Text, ActivityIndicator } from 'react-native';
import Config from 'react-native-config';
import styled from 'styled-components/native';
import { storage } from '@/atoms/atomForLocal';
import { api, apiConfig } from '../config/api';
export default function KakaoCallbackScreen() {
    const [error, setError] = useState(null);
    useEffect(() => {
        const handleOAuthCallback = () => __awaiter(this, void 0, void 0, function* () {
            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code');
            const state = urlParams.get('state');
            // Decode the post-login destination from `state`. Never return to the
            // auth screens themselves — fall back to home so login lands on home when
            // there's no explicit next/redirect target.
            let decodedPath = state ? decodeURIComponent(state) : '/';
            if (!decodedPath.startsWith('/') ||
                decodedPath === '/login' ||
                decodedPath.startsWith('/login') ||
                decodedPath.startsWith('/signup') ||
                decodedPath.startsWith('/oauth')) {
                decodedPath = '/';
            }
            const nextUrl = window.location.origin + decodedPath;
            if (!code) {
                setError('인증 코드가 없습니다.');
                setTimeout(() => {
                    window.location.href = nextUrl;
                }, 2000);
                return;
            }
            // 빌드 시 webpack 이 KAKAO_JS_KEY 존재를 검증하므로 정상 빌드에선 항상 존재한다.
            // 그래도 폴백 키로 조용히 잘못 교환하지 않도록 fail-loud 가드를 둔다.
            const kakaoJsKey = Config.KAKAO_JS_KEY;
            if (!kakaoJsKey) {
                setError('카카오 로그인 설정이 올바르지 않습니다.');
                setTimeout(() => {
                    window.location.href = nextUrl;
                }, 2000);
                return;
            }
            try {
                // Exchange code for tokens using Kakao REST API
                const tokenResponse = yield fetch('https://kauth.kakao.com/oauth/token', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        grant_type: 'authorization_code',
                        // 토큰 교환 client_id = authorize 와 동일한 JS키. 카카오 /oauth/token 은
                        // JS키도 client_id 로 허용하며(실측 확인), 이때 발급되는 idToken 의 aud 가
                        // 그 JS키가 된다. 백엔드는 웹 idToken 의 aud 를 web-oauth-client-id(=이 JS키)
                        // 로 검증하므로 일치해야 한다. (REST키로 교환하면 aud=REST키가 되어
                        // 백엔드에서 "audience does not match" 발생 — KOE 아님, 백엔드 검증 실패.)
                        // 하드코딩 폴백 금지 — authorize 와 동일 키여야 KOE114(Application ID
                        // mismatch)가 안 난다. 값은 빌드 시 webpack 이 검증한다.
                        client_id: kakaoJsKey,
                        redirect_uri: window.location.origin + '/oauth/kakao',
                        code: code,
                    }),
                });
                if (!tokenResponse.ok) {
                    throw new Error('Token exchange failed');
                }
                const kakaoTokens = yield tokenResponse.json();
                const now = Date.now();
                const accessTokenExpiresAt = now + kakaoTokens.expires_in * 1000;
                const refreshTokenExpiresAt = now + (kakaoTokens.refresh_token_expires_in || 5184000) * 1000;
                // Call backend login API
                const response = yield api.loginWithKakaoPost({
                    kakaoTokens: {
                        accessToken: kakaoTokens.access_token,
                        refreshToken: kakaoTokens.refresh_token || '',
                        idToken: kakaoTokens.id_token || '',
                        accessTokenExpiresAt: { value: accessTokenExpiresAt },
                        refreshTokenExpiresAt: { value: refreshTokenExpiresAt },
                    },
                });
                const { authTokens, user } = response.data;
                // Store into the app's MMKV-backed storage (scc-token / userInfo) so the
                // real app tree (accessTokenAtom / userInfoAtom) picks it up on reload.
                // Values are JSON-stringified to match atomForLocal's encoding.
                storage.set('scc-token', JSON.stringify(authTokens.accessToken));
                storage.set('userInfo', JSON.stringify(user));
                apiConfig.accessToken = authTokens.accessToken;
                console.log('Kakao login successful, redirecting to:', nextUrl);
                // Redirect to original page
                window.location.href = nextUrl;
            }
            catch (err) {
                console.error('OAuth callback handling failed:', err);
                setError('로그인 처리 중 오류가 발생했습니다.');
                setTimeout(() => {
                    window.location.href = nextUrl;
                }, 2000);
            }
        });
        handleOAuthCallback();
    }, []);
    return (_jsx(Container, { children: error ? (_jsxs(_Fragment, { children: [_jsx(ErrorText, { children: error }), _jsx(SubText, { children: "\uC7A0\uC2DC \uD6C4 \uC774\uC804 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4..." })] })) : (_jsxs(_Fragment, { children: [_jsx(ActivityIndicator, { size: "large", color: "#007AFF" }), _jsx(LoadingText, { children: "\uCE74\uCE74\uC624 \uB85C\uADF8\uC778 \uCC98\uB9AC \uC911..." })] })) }));
}
const Container = styled(View) `
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
`;
const LoadingText = styled(Text) `
  font-size: 16px;
  color: #333333;
  margin-top: 16px;
`;
const ErrorText = styled(Text) `
  font-size: 16px;
  color: #dc3545;
  margin-bottom: 8px;
`;
const SubText = styled(Text) `
  font-size: 14px;
  color: #666666;
`;
